import copyicon from '../assets/images/copy-promo-code.svg'
import {React, Button, useNavigate, useParams, useState } from '../utils/thirdpartyComponents'
import clipboard from 'clipboard-copy'
import { MessageToaster } from '../utils/toastUtil'
import moment from "moment";

const PromotionDetail = ({ name, description, promocode, validity, washName , onBuynowClick, promotion, buyType}: any) => {

    const navigate = useNavigate()
    // Route information variable
    const params = useParams();
 
    // Instantiate MessageToaster
    const toaster = new MessageToaster();

    // State to manage more and less button
    const [showAll, setShowAll] = useState(false);

    // Determine which items to display based on showAll state
    const visibleDescription = showAll ? description : (description.length > 120 ? `${description.substring(0, 120)}...` : description)

    const toggleShowAll = () => {
        setShowAll(!showAll);
    };

    //To copy promocode
    const handleCopy = () => {
        clipboard(promocode);
        toaster.toastSuccess("Code copied to clipboard!")
    };
    return (
        <div className="cw-card">
            <div className="cw-card-content">
                <div className="cw-card-leftcontent">
                    <h6>{name}</h6>
                    <p>{visibleDescription}</p>
                    {description.length > 120 && (
                        <a onClick={toggleShowAll} className="more-less-btn">
                            {showAll ? <>
                                <span className="align-text-top">Less</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="8.148" height="10.365" viewBox="0 0 8.148 10.365"><g transform="translate(1.061 9.615) rotate(-90)"><g transform="translate(-7.003 -9.256)"><line x2="8.199" transform="translate(7.003 12.269)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /><path d="M13,8l3.014,3.014L13,14.027" transform="translate(-0.146 1.256)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /></g></g></svg>
                            </> : <><span className="align-text-top">More</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="8.148" height="10.365" viewBox="0 0 8.148 10.365"><g transform="translate(7.088 0.75) rotate(90)"><g transform="translate(-7.003 -9.256)"><line x2="8.199" transform="translate(7.003 12.269)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /><path d="M13,8l3.014,3.014L13,14.027" transform="translate(-0.146 1.256)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /></g></g></svg>
                            </>}
                        </a>
                    )}
                </div>
            </div>
            <div className="promo-code d-flex align-items-center justify-content-between">
                <p>Promo Code <span>{promocode}</span></p>
                <span onClick={handleCopy}><img src={copyicon} alt="Car Wash App" /></span>
            </div>
            <div className="date">
                <p>Wash Name <span> {washName}</span></p>
            </div>
            <div className="date">
                <p>Valid Till <span> {moment(new Date(validity)).format("MMMM D, YYYY")}</span></p>
            </div>
            
            <div className="cw-card-btnwrap">
                {/* <Button variant="primary" className="primary-btn" onClick={() => navigate("/"+params.carwashname+"/"+pageURLs.payment, { state: { origin: 'Promotion' } })}>Buy Now</Button> */}
                <Button variant="primary" className="primary-btn" onClick={() => onBuynowClick(promotion, buyType === 2 ? "subscriptions" : "singlewash")}>Buy Now</Button>
            </div>
        </div >
    )
}

export default PromotionDetail